"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castegnato": {
    "38934f56": [{
      "hkey": "12185fc1",
      "slug": "castegnato",
      "name": "Castegnato",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "12185fc1",
      "slug": "castegnato",
      "name": "Castegnato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7f8002b": [{
      "hkey": "12185fc1",
      "slug": "castegnato",
      "name": "Castegnato",
      "primary": true,
      "skipSearch": false
    }],
    "piazzetta": [{
      "hkey": "12185fc1",
      "slug": "castegnato",
      "name": "Castegnato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4fb7d37": [{
      "hkey": "12185fc1",
      "slug": "castegnato",
      "name": "Castegnato",
      "primary": true,
      "skipSearch": false
    }],
    "porte": [{
      "hkey": "12185fc1",
      "slug": "castegnato",
      "name": "Castegnato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d83ebea3": [{
      "hkey": "12185fc1",
      "slug": "castegnato",
      "name": "Castegnato",
      "primary": true,
      "skipSearch": false
    }],
    "torre": [{
      "hkey": "12185fc1",
      "slug": "castegnato",
      "name": "Castegnato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;